import React, { useContext, useEffect, useState, createContext } from 'react';
import { makeStyles, withStyles, createMuiTheme } from '@material-ui/core/styles';
import clsx from 'clsx';
import { Stepper, Step, StepLabel, Grid, Box } from '@material-ui/core';
import StepConnector from '@material-ui/core/StepConnector';
import Button from '@material-ui/core/Button';
import WifiIcon from '@material-ui/icons/Wifi';
import TvIcon from '@material-ui/icons/Tv';
import PhoneIphoneIcon from '@material-ui/icons/PhoneIphone';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import { isMobile, isTablet, isMobileOnly } from "react-device-detect";

const defaultTheme = createMuiTheme();
const ColorlibConnector = withStyles({
    alternativeLabel: {
        top: (isMobileOnly) ? 22 : 16,
    },
    alternativeLabel: {
        top: 22,
        [defaultTheme.breakpoints.down(768)]: {
            top: 16,
            left: -50,
        }
    },
    active: {
        '& $line': {
            backgroundImage:
                'linear-gradient( 95deg,rgba(148,62,169,255) 0%,rgba(174,53,184,255) 50%,rgba(210,39,204,255) 100%)',
        },
    },
    completed: {
        '& $line': {
            backgroundImage:
                'linear-gradient( 95deg,rgba(148,62,169,255) 0%,rgba(174,53,184,255) 50%,rgba(210,39,204,255) 100%)',
        },
    },
    line: {
        height: '0.15rem',
        border: 0,
        backgroundColor: '#eaeaf0',
        borderRadius: 1,
        width: 96,
        margin: '0 auto',
    },
})(StepConnector);

const useColorlibStepIconStyles = makeStyles({
    root: {
        backgroundColor: '#ccc',
        zIndex: 1,
        color: '#fff',
        width: 30,
        height: 30,
        display: 'flex',
        borderRadius: '50%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    active: {
        boxShadow: '0 4px 10px 0 rgba(0,0,0,.25)',
        backgroundSize: 100,
        background: 'linear-gradient(#cc44cc, transparent) #570264',
    },
    completed: {
        background: 'linear-gradient(#cc44cc, transparent) #570264',
    },
});

function ColorlibStepIcon(props) {
    const classes = useColorlibStepIconStyles();
    const { active, completed } = props;


    const icons = {
        1: <WifiIcon />,
        2: <TvIcon />,
        3: <PhoneIphoneIcon />,
    };

    return (
        <div
            className={clsx(classes.root, {
                [classes.active]: active,
                [classes.completed]: completed,
            })}
        >
            {icons[String(props.icon)]}
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        "& .makeStyles-button-2 ": {
            outline: 'none',
        },
        "& .MuiSvgIcon-root": {
            width: '.85rem',
        },
        "& .MuiButton-label": {
            fontFamily: 'eir-bold !important',
            paddingLeft: '5px',
            paddingRight: '5px',
            textTransform: 'none',
        },

        ".MuiSvgIcon-root": {
            width: 120,
        },
    },
    next_button: {
        // background: 'url(https://www.eir.ie/opencms/export/system/modules/ie.eir/resources/images/arrow_right_pink2x.png) no-repeat',
        // width: 33,
        // height: 33,
        // display: 'inline',
        // backgroundSize: '30px 30px',
        // cursor: 'pointer',
        // color: '#fff !important',
        // backgroundColor: '#892ba0 !important',

    },
    back_button: {
        backgroundColor: '#fff',
        //     background: 'url(https://www.eir.ie/opencms/export/system/modules/ie.eir/resources/images/arrow-left-hover.png) no-repeat',
        //     width: 33,
        //     height: 33,
        //     display: 'inline',
        //     backgroundSize: '30px 30px',
        //     cursor: 'pointer',
    },
}));

function getSteps() {
    if (JSON.parse(localStorage.getItem("eir_be_data")).order) {// if TV is available
        let bbType = JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.broadband.plan.type;
        if (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.inbi ==true)
            return ['Broadband'];
        if (bbType === 'NGB')
            return ['Broadband', 'Mobile'];

        else 
            return ['Broadband', 'TV', 'Mobile'];
    }
}

export default function EirCustomiseBundleStepper(props) {
    const { setCustmiseCheckoutActiveStep } = props
    const classes = useStyles();
    const [activeStep, setActiveStep] = React.useState(1);
    const steps = getSteps();
    const isNGB = (localStorage.getItem("eir_be_data")) ? (JSON.parse(localStorage.getItem("eir_be_data")).order.bundle.broadband.plan.type) : "";
    const isNBI =   (localStorage.getItem("eir_be_data")) ? (JSON.parse(localStorage.getItem("eir_be_data")).order.prequal.inbi) : "";
    //**** click of next button ****/
    const handleNext = () => {
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
        setCustmiseCheckoutActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
        setCustmiseCheckoutActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    //**** click of stepper ****/
    const handleStep = (step) => () => {

        if (($('input[name=mobilePlans]:checked').val()) != "withPhone") {
            setActiveStep(step);
            setCustmiseCheckoutActiveStep(step);
        }
        else if ((step == 3) && (activeStep == 2) && ((JSON.parse(localStorage.getItem("eir_be_data")).mobilesOnOrder.length < 1) || ($('input[name=portingOptions]:checked').length < 1))) {
            setModal(true);
        }
        else {
            setActiveStep(step);
            setCustmiseCheckoutActiveStep(step);
        }
    };

    useEffect(() => {
        let headerTag = document.getElementsByTagName("header")[0];
        let getStepperNode = document.getElementById("customise_checkout_stepper");
        let getTilesComponent = document.querySelector(".step-tile-component");
        headerTag.append(getStepperNode);
        setActiveStep(0);
    }, []);

    return (
        <div className={classes.root}>
            {!isNBI && <div onClick={(activeStep === 0) ? '' : handleBack} className={(activeStep === 0) ? "grey_back float-left step_back " : " float-left step_back " + ((!isMobileOnly) ? ' ml-4 ' : '') + classes.back_button}>
                Back</div>}
            <Grid item xs={12} id="customise_checkout_stepper" className={(isNGB === "NGB") ? " ngb_stepper" : "" +`${isNBI ? "nbi_stepper":''}`}>
                <Box display={{ xs: 'none', md: 'block' }} >
                    <Stepper activeStep={activeStep} connector={<ColorlibConnector />}>
                        {steps.map((label, index) => (
                            <Step key={label}>
                                <StepLabel onClick={handleStep(index)} StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                            </Step>

                        ))}
                    </Stepper>
                </Box>
                <Box display={{ xs: 'block', md: 'none' }}>
                    <Stepper alternativeLabel activeStep={activeStep} connector={<ColorlibConnector />}>
                        {steps.map((label, index) => (
                            <Step key={label} id={"step-" + index}>
                                <StepLabel onClick={handleStep(index)} StepIconComponent={ColorlibStepIcon}>{label}</StepLabel>
                            </Step>
                        ))}
                    </Stepper>
                </Box>
            </Grid >

            {!isNBI && <div class={(activeStep === steps.length - 1) ? "grey_next  float-right step_next " : " float-right step_next " + ((!isMobileOnly) ? ' mr-4 ' : '') + classes.next_button} onClick={(activeStep === steps.length - 1) ? '' : handleNext} > Next</div> }
            {(activeStep === 3) &&
                <div class="orderSummaryHeading w-100 purple-text d-flex justify-content-center align-items-center">Your Order Summary</div>
            }
        </div >
    );
}
